export const formatNationalityChartData = (bookingList, chartTitle) => {
  const nationalityCounts = bookingList.reduce((acc, booking) => {
    const countryName = booking.guestNationality || "Unknown";
    acc[countryName] = (acc[countryName] || 0) + 1;
    return acc;
  }, {});

  const labels = Object.keys(nationalityCounts);
  const data = Object.values(nationalityCounts);

  const backgroundColors = [
    "#3B82F6",
    "#EF4444",
    "#10B981",
    "#F59E0B",
    "#8B5CF6",
    "#EC4899",
    "#6B7280",
  ];
  const colors = labels.map(
    (_, index) => backgroundColors[index % backgroundColors.length]
  );

  return {
    labels,
    datasets: [
      {
        label: chartTitle,
        data,
        backgroundColor: colors,
        borderColor: colors.map((color) => color.replace("500", "600")),
        borderWidth: 2,
      },
    ],
  };
};
